import { useEffect, useState } from "react";

import { Slider, SliderProps } from "@mui/material";

type SliderWithCommitProps = SliderProps;

const SliderWithCommit = ({ value, onChangeCommitted, ...props }: SliderWithCommitProps) => {
  const [tempValue, setTempValue] = useState<SliderProps["value"]>(value);

  useEffect(() => {
    setTempValue(value);
  }, [value]);

  return (
    <Slider
      {...props}
      value={tempValue}
      onChange={(...args) => {
        setTempValue(args[1]);
      }}
      onChangeCommitted={onChangeCommitted}
    />
  );
};

export default SliderWithCommit;
